<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t("lang.my_notifications") }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-refresh @invoke-method="dbGetNotifications(true)"></bc-btn-refresh>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-layout row wrap>
                    <v-flex xs12 lg3>
                        <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                            <v-list two-line>
                                <v-list-tile class="v-list-title" :style="{ backgroundColor: '#dde6f3', height: '48px' }">
                                    <v-list-tile-action
                                        ><v-icon>{{ parseInt(page.new_notifications) > 0 ? "markunread" : "check" }}</v-icon></v-list-tile-action
                                    >
                                    <v-list-tile-content>
                                        <v-list-tile-title
                                            ><span class="fw-bold">{{
                                                page.new_notifications > 0 ? `${page.new_notifications} unread notification(s).` : "All caught up."
                                            }}</span></v-list-tile-title
                                        >
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-divider></v-divider>
                                <vue-perfect-scrollbar class="scroll-area" :style="$bp.xs ? null : 'height: calc(100vh - 335px)'">
                                    <template v-for="(notification, index) in notifications">
                                        <v-list-tile
                                            :style="{
                                                backgroundColor:
                                                    selectedNotification && selectedNotification.notification_id == notification.notification_id
                                                        ? '#dde6f3'
                                                        : '',
                                                borderBottom: '1px solid #ddd',
                                                cursor: 'pointer',
                                            }"
                                            @click="selectNotification(notification)"
                                        >
                                            <v-list-tile-action>
                                                <v-icon :color="notification.icon_class">{{ notification.icon }}</v-icon>
                                            </v-list-tile-action>

                                            <v-list-tile-content>
                                                <v-list-tile-title :class="[notification.read_flag == 0 ? 'fw-bold' : '']">{{
                                                    notification.subject
                                                }}</v-list-tile-title>
                                                <v-list-tile-sub-title>{{ notification.date_created }}</v-list-tile-sub-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon
                                                    :color="
                                                        notification.read_flag == 1
                                                            ? selectedNotification && selectedNotification.notification_id == notification.notification_id
                                                                ? 'white'
                                                                : '#ddd'
                                                            : ''
                                                    "
                                                    >{{ notification.read_flag == 0 ? "markunread" : "drafts" }}</v-icon
                                                >
                                            </v-list-tile-action>
                                        </v-list-tile>
                                    </template>
                                </vue-perfect-scrollbar>
                            </v-list>
                            <bc-pagination :page="page" :params="axiosParams" name="me-notifications"></bc-pagination>
                        </v-card-text>
                        <v-divider vertical inset v-if="!$bp.smallScreen"></v-divider>
                    </v-flex>

                    <v-flex xs12 lg9 :style="{ height: 'calc(100vh - 335px)' }">
                        <h1 style="color: #ddd; align-self: center; justify-self: center" v-if="selectedNotification == null">
                            {{ $t("lang.view_notification") }}
                        </h1>
                        <v-card-text v-else>
                            <v-container grid-list-md>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-layout row wrap>
                                            <v-flex xs10>
                                                <v-text-field v-model="selectedNotification.subject" label="Subject" hide-details readonly></v-text-field>
                                            </v-flex>
                                            <v-flex xs2>
                                                <v-text-field v-model="selectedNotification.date_created" label="Date Sent" readonly></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex xs12>
                                        <!-- <v-textarea
                                            :value="selectedNotification.message"
                                            :label="`${$t('lang.message')}`"
                                            hide-details
                                            scroll
                                            rows="32"
                                            readonly
                                            style="border-color: #dddd"
                                            outline
                                        ></v-textarea> -->
                                        <vue-perfect-scrollbar class="scroll-area" :style="$bp.xs ? null : 'height: calc(100vh - 340px)'">
                                            <div v-html="selectedNotification.message"></div>
                                        </vue-perfect-scrollbar>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                    </v-flex>
                </v-layout>
            </v-card>

            <bc-dialog :value="notification_dialog" fullscreen>
                <v-card>
                    <v-form ref="form_notification">
                        <v-card-title>
                            <span class="headline">{{ notification.notification_id ? $t("lang.edit_notification") : $t("lang.add_notification") }}</span>
                            <v-spacer horizontal></v-spacer>

                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeNotificationDialog"
                                :dialog-status="notification_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <vue-perfect-scrollbar class="scroll-area" :style="$bp.xs ? null : 'max-height: calc(100vh - 160px);'">
                                <v-container grid-list-form>
                                    <v-layout row wrap>
                                        <v-flex xs10>
                                            <v-text-field
                                                v-focus="notification_dialog"
                                                v-model="notification.notification_id"
                                                :label="$t('lang.notification_id')"
                                                :counter="showCounter(notification.notification_id, 'notifications.notification_id')"
                                                :rules="ifValid('notifications.notification_id')"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-switch
                                                v-model="notification.modal"
                                                :label="`${notification.modal == 1 ? $t('lang.modal') : $t('lang.non_modal')}`"
                                                true-value="1"
                                                false-value="0"
                                            >
                                            </v-switch>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field
                                                v-model="notification.subject"
                                                :label="$t('lang.subject')"
                                                :counter="showCounter(notification.subject, 'notifications.subject')"
                                                :rules="ifValid('notifications.subject')"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-textarea
                                                style="padding-top: 0px !important"
                                                :value="notification.message"
                                                :label="`${$t('lang.message')} *`"
                                                hide-details
                                                outline
                                                scroll
                                                rows="20"
                                                :rules="ifValid('notifications.message')"
                                            ></v-textarea>
                                        </v-flex>
                                        <v-flex xs4>
                                            <v-text-field
                                                v-model="notification.object_name"
                                                :label="$t('lang.object_name')"
                                                :counter="showCounter(notification.object_name, 'notifications.object_name')"
                                                :rules="ifValid('notifications.object_name')"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs4>
                                            <v-text-field
                                                v-model="notification.object_id"
                                                :label="$t('lang.object_id')"
                                                :counter="showCounter(notification.object_id, 'notifications.object_id')"
                                                :rules="ifValid('notifications.object_id')"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs4>
                                            <v-text-field
                                                v-model="notification.file"
                                                :label="$t('lang.file')"
                                                :counter="showCounter(notification.file, 'notifications.file')"
                                                :rules="ifValid('notifications.file')"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-text-field
                                                v-model="notification.icon"
                                                :label="$t('lang.icon')"
                                                :counter="showCounter(notification.icon, 'notifications.icon')"
                                                :rules="ifValid('notifications.icon')"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-text-field
                                                v-model="notification.icon_class"
                                                :label="$t('lang.icon_class')"
                                                :counter="showCounter(notification.icon_class, 'notifications.icon_class')"
                                                :rules="ifValid('notifications.icon_class')"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </vue-perfect-scrollbar>
                        </v-card-text>
                    </v-form>
                    <v-card-actions>
                        <v-btn v-if="notification.notification_id" color="error" @mouseup.left="$refs.delete_notifications.openDialog()">{{
                            $t("lang.delete")
                        }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="closeNotificationDialog()">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn color="success" @click="saveNotifications">{{ $t("lang.save") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_notifications"
                :heading="$t('lang.delete_notification')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteNotifications(notification.notification_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openNotificationForm" },
                { title: this.$t("lang.refresh"), action: "dbGetNotifications", params: [true] },
            ],
            headers: [
                { sortable: false, width: "2%" },
                { text: this.$t("lang.notification_id"), sortable: false, width: "5%" },
                { text: this.$t("lang.notify_place"), sortable: false, width: "15%" },
                { text: this.$t("lang.name"), sortable: false, width: "25%" },
                { text: this.$t("lang.subject"), sortable: false, width: "15%" },
                { text: this.$t("lang.object_name"), sortable: false, width: "10%" },
                { text: this.$t("lang.object_id"), sortable: false, width: "10%" },
                { text: this.$t("lang.modal"), align: "center", sortable: false, width: "10%" },
                { text: this.$t("lang.icon"), align: "center", sortable: false, width: "5%" },
                { text: this.$t("lang.date_sent"), align: "center", sortable: false, width: "5%" },
            ],
            enableAddModal: true,
            enableEditModal: true,

            notification: {},
            filter: {
                search: "",
                people_id: "",
                status: "",
            },
            notification_dialog: false,
            dbGetNotifications: _.debounce(this.getNotifications, 1500, { maxWait: 1500, leading: true, trailing: false }),
            selectAll: false,
            selectedNotification: null,
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        if (to.path.includes("me")) {
            store
                .dispatch("fetchMeNotifications", {
                    body: parsedQuery,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.notifications) {
                        next((vm) => {
                            vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "dashboard", replace: true });
                    }
                });
        } else {
            store
                .dispatch("fetchNotifications", {
                    body: parsedQuery,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.notifications) {
                        next((vm) => {
                            vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "dashboard", replace: true });
                    }
                });
        }
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        if (to.path.includes("me")) {
            this.fetchMeNotifications({
                body: parsedQuery,
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.notification_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(false);
                    next();
                });
        } else {
            this.fetchNotifications({
                body: parsedQuery,
                body: parsedQuery,
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.notification_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(false);
                    next();
                });
        }
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.notifications.notifications_filter,
            page: (state) => state.notifications.notifications_page,
            rules_notifications: (state) => state.notifications.rules_notifications,
            notification_status_options: (state) => state.settings.notification_status_options,
            notifications: (state) => state.notifications.notifications,
            people: (state) => state.people.person_options,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
        unreadNotifications() {
            return this.notifications.filter((notification) => notification.read_flag == 0).length;
        },
    },
    methods: {
        ...mapActions(["fetchNotifications", "saveNotification", "deleteNotification", "fetchMeNotifications", "fetchPeople"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openNotificationForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.$refs.form_notification) item ? this.$refs.form_notification.resetValidation() : this.$refs.form_notification.reset();

                    this.$nextTick(() => {
                        this.notification = item != null ? this.assignObj2(item, this.rules_notifications) : {};
                        this.notification_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "notification", params: { id: item.notification_id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.$refs.form_notification) item ? this.$refs.form_notification.resetValidation() : this.$refs.form_notification.reset();
                    this.notification_dialog = true;
                } else {
                    this.$router.push({ name: "notification" });
                }
            }
        },
        saveNotifications() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_notification")) {
                    let body = this.prepForm(this.notification, this.rules_notifications);

                    this.saveNotification({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getNotifications();
                                this.closeNotificationDialog();
                            } else {
                                this.$router.push({ name: "notification", params: { id: data.notification_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteNotifications(id = null) {
            this.deleteNotification({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getNotifications();
                    this.closeNotificationDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeNotificationDialog() {
            this.notification_dialog = false;
            this.$refs.delete_notifications.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getNotifications(pg_refresh = false) {
            this.startLoader();

            if (this.$route.path.includes("me")) {
                this.fetchMeNotifications({
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                    .then((data) => {
                        if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                    })
                    .finally(() => {
                        this.notification_dialog = false;
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(pg_refresh);
                    });
            } else {
                this.fetchNotifications({
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                    .then((data) => {
                        if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                    })
                    .finally(() => {
                        this.notification_dialog = false;
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(pg_refresh);
                    });
            }
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        getPeople() {
            this.fetchPeople({ body: { options: 1 } });
        },
        selectNotification(notification) {
            this.selectedNotification = { ...notification };
            if (this.selectedNotification.read_flag == 0) {
                this.$nextTick(() => {
                    this.selectedNotification.read_flag = 1;
                    let body = this.prepForm(this.selectedNotification, this.rules_notifications);
                    this.saveNotification({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            this.getNotifications();
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                });
            }
        },
    },
    mounted() {
        this.getPeople();
    },
};
</script>
<style>
.v-list-title > .v-list__tile {
    height: 48px !important;
}

.theme--light.v-text-field--outline:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot {
    border-color: #ddd !important;
}
</style>
